// src/components/User/ProfileSettings.jsx
import React, { useState, useEffect } from 'react';
import { supabase, API_BASE } from '../../App';
import { toast } from 'react-toastify';
import './ProfileSettings.css';

const ProfileSettings = ({ session, onNavigate }) => {
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState({
        username: '',
        phone: '',
        bgmi_username: '',
        display_name: ''
    });

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const { data, error } = await supabase
                .from('profiles')
                .select('*')
                .eq('id', session.user.id)
                .single();

            if (error) throw error;
            setProfile({
                username: data.username || '',
                phone: data.phone || '',
                bgmi_username: data.bgmi_username || '',
                display_name: data.display_name || data.username || ''
            });
        } catch (error) {
            console.error('Error fetching profile:', error);
            toast.error('Failed to load profile');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const { error } = await supabase
                .from('profiles')
                .update({
                    display_name: profile.display_name,
                    phone: profile.phone,
                    bgmi_username: profile.bgmi_username,
                    updated_at: new Date().toISOString()
                })
                .eq('id', session.user.id);

            if (error) throw error;

            toast.success('Profile updated successfully!');
        } catch (error) {
            console.error('Error updating profile:', error);
            toast.error(error.message || 'Failed to update profile');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setProfile({
            ...profile,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="profile-settings">
            <div className="profile-header">
                <h2>⚙️ Profile Settings</h2>
                <p>Update your personal information</p>
            </div>

            <form onSubmit={handleSubmit} className="profile-form">
                <div className="form-group">
                    <label htmlFor="username">
                        Username
                        <span className="label-hint">(Cannot be changed)</span>
                    </label>
                    <input
                        type="text"
                        id="username"
                        value={profile.username}
                        disabled
                        className="form-input disabled"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="display_name">
                        Display Name
                        <span className="label-required">*</span>
                    </label>
                    <input
                        type="text"
                        id="display_name"
                        name="display_name"
                        value={profile.display_name}
                        onChange={handleChange}
                        placeholder="Enter your display name"
                        className="form-input"
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="bgmi_username">
                        BGMI Username
                        <span className="label-required">*</span>
                    </label>
                    <input
                        type="text"
                        id="bgmi_username"
                        name="bgmi_username"
                        value={profile.bgmi_username}
                        onChange={handleChange}
                        placeholder="Enter your BGMI username"
                        className="form-input"
                        required
                    />
                    <small className="form-hint">Required to participate in matches</small>
                </div>

                <div className="form-group">
                    <label htmlFor="phone">
                        Phone Number
                    </label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={profile.phone}
                        onChange={handleChange}
                        placeholder="+91 XXXXXXXXXX"
                        className="form-input"
                        pattern="[+]?[0-9]{10,15}"
                    />
                    <small className="form-hint">For withdrawal and verification</small>
                </div>

                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        value={session.user.email}
                        disabled
                        className="form-input disabled"
                    />
                    <small className="form-hint">Email cannot be changed</small>
                </div>

                <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                >
                    {loading ? 'Saving...' : '💾 Save Changes'}
                </button>

                <div style={{ marginTop: '30px', borderTop: '1px solid var(--border-color)', paddingTop: '20px', paddingBottom: '20px' }}>
                    <button
                        type="button"
                        className="btn btn-outline"
                        style={{ width: '100%', borderColor: 'var(--danger-color)', color: 'var(--danger-color)' }}
                        onClick={async () => {
                            if (window.confirm('Are you sure you want to log out?')) {
                                await supabase.auth.signOut();
                                window.location.href = '/login';
                            }
                        }}
                    >
                        🚪 Sign Out
                    </button>
                </div>

                {/* Manage Teams Button */}
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        style={{ flex: 1 }}
                        onClick={() => {
                            if (onNavigate) {
                                onNavigate('teams'); // State mode
                            } else {
                                window.location.href = '/dashboard/teams'; // Router mode fallback
                            }
                        }}
                    >
                        👥 Manage Teams
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline"
                        style={{ flex: 1 }}
                        onClick={() => {
                            if (onNavigate) {
                                onNavigate('withdrawal'); // State mode
                            } else {
                                window.location.href = '/dashboard/withdrawal'; // Router mode fallback
                            }
                        }}
                    >
                        💸 Withdraw
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ProfileSettings;
